<div class="dialog-container">
  <div class="activity-code">
    <div class="event-box" [class.dfp]="isDFP" [class.non-dfp]="!isDFP && !isSeqError" [class.seq-error]="isSeqError">
      {{ data.code }}
    </div>
  </div>
  <div class="description" [class.warn-color]="isSeqError">
    {{ data.description }}
  </div>
  <div *ngIf="data.sequenceNumber && !isSeqError" class="text-center">
    <mat-divider class="divider"></mat-divider>
    <button mat-button color="primary" (click)="onViewSeqClick()" class="text-base" tabindex="-1">View Sequence</button>
  </div>
  <div *ngIf="data.sequenceNumber && isSeqError" class="text-center">
    <mat-divider class="divider"></mat-divider>
    <button mat-button color="primary" (click)="onViewHssClick()" class="text-base" tabindex="-1">View Sequence
      (Sabre)</button>
  </div>
</div>